export const ApisProvider = {
  bdProvider: "https://waxtestnet.greymass.com",
  ipfsProvider: "https://ipfs.io/ipfs/",
  explorerProvider: "https://wax-test.bloks.io/transaction/",
  atomicApi: "https://test.wax.api.atomicassets.io/",
  actionsApi: "https://testnet.waxsweden.org/"
};

export const ChainWire = {
  chainUrl: "https://waxtestnet.greymass.com",
  chainId: "f16b1833c747c43682f4386fca9cbb327929334a762755ebec17f6f23c9b8a12"
};

export const ExtinctionData = {
  collectionName: "extinctionwa",
  LOCATION_ID_SILKHS: "permafrost",
  EXPEDITION_SLOTS_SILKHS: [0, 1],
  LOCATION_ID_ARAK: "desertscaves",
  EXPEDITION_SLOTS_ARAK: [2, 3],
  LOCATION_ID_COUNCILC: "councilcity",
  EXPEDITION_SLOTS_COUNCILC: [4, 5],
  LOCATION_ID_DUMMIES: "trainingcamp",
  EXPEDITION_SLOTS_DUMMIES: [6, 7],
  EXTINCTION_CONTRACT: "extinctionwa", // CONTRACT EXPEDITONS
  GEARS_CONTRACT: "gearcontract", // CONTRACT GEARS
  ONYX_CONTRACT: "waxonyxtoken", // CONTRACT ONYXS AND TOKENS
  TABLE_ALCHEMIST: "alchemist",
  TABLE_UNBOXASSETS: "unboxassets",
  TABLE_UNBOXPACKS: "unboxpacks",
  TABLE_SCRAPYARD: "scrapyard",
  TABLE_SLOTS_ARAK: "araks",
  TABLE_SLOTS_SILKHS: "silkhs",
  TABLE_SLOTS_DUMMIES: "training",
  TABLE_SLOTS_RISKY: "risky",
  TABLE_SLOTS_EXTRAS: "extras",
  TABLE_EXPEDITIONS_00: "expeditions",
  TABLE_EXPEDITIONS_01: "expeditions1",
  TABLE_EXPEDITIONS_02: "expeditions2",
  TABLE_EXPEDITIONS_03: "expeditions3",
  TABLE_EXPEDITIONS_04: "expeditions4",
  TABLE_EXPEDITIONS_05: "expeditions5",
  TABLE_EXPEDITIONS_06: "traincamp",
  TABLE_EXPEDITIONS_07: "traincamp1",
  TABLE_REWARDFEES: "rewardfees", // FEES GEARS
  TABLE_INGAMEFEES: "ingamefee", // FEES INGAME
  TABLE_SUIT_WORKSHOP: "workshopsuit",
  TABLE_WEAPON_WORKSHOP: "workshopwep",
  TABLE_HEROES: "heroes",
  TABLE_STARTERKIT: "starterkit",
  TABLE_CREATORSFEES: "creatorfees",
  ID_SALE_CRATE_DOUBLE: "447181", // PRESALE CRATES DOUBLE
  ID_SALE_CRATE_SUIT: "447179", // PRESALE CRATES SUITS
  ID_SALE_CRATE_WEAPON: "447180", // PRESALE CRATES WEAPONS
  ID_REWARD_DUMMY_BOX_BOX: "452068",
  ID_REWARD_NOTHING_2: -2,
  ID_REWARD_NOTHING: -1,
  ID_REWARD_ONYX_1: 1,
  ID_REWARD_ONYX_2: 2,
  ID_REWARD_ONYX_3: 3,
  ID_REWARD_ONYX_4: 4,
  ID_REWARD_NEO_COMMON: 5,
  ID_REWARD_NEO_RARE: 6,
  ID_REWARD_NEO_EPIC: 7,
  ID_REWARD_NEO_LEGEND: 8,
  ID_REWARD_CHAL_COMMON: 9,
  ID_REWARD_CHAL_RARE: 10,
  ID_REWARD_CHAL_EPIC: 11,
  ID_REWARD_CHAL_LEGEND: 12,
  ID_REWARD_ONYX_13: 13,
  ID_DUMMY_SUIT: "452066",
  ID_DUMMY_WEAPON: "452067",
  ID_TICKETS_WL: "452069"
};

export const ExtinctionVideoData = {
  loader: "/vids/LOADER.mp4",
  loaderMobile: "https://extinctionwars.com/assets/videos/loader_resp_2.mp4"
};

export const ItemsData = {
  weapons: [
    {
      templateId: "446853",
      name: "AR-21",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/car21.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/car21.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/car21.mp4"
      },
      nation: "Silkhs",
      power: "100",
      rarity: "Common"
    },
    {
      templateId: "446854",
      name: "AR-21",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/rar21.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/rar21.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/rar21.mp4"
      },
      nation: "Silkhs",
      power: "200",
      rarity: "Toxic"
    },
    {
      templateId: "446855",
      name: "AR-21",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/ear21.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/ear21.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/ear21.mp4"
      },
      nation: "Silkhs",
      power: "300",
      rarity: "Frost"
    },
    {
      templateId: "446856",
      name: "AR-21",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/lar21.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/lar21.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/lar21.mp4"
      },
      nation: "Silkhs",
      power: "400",
      rarity: "Dark Matter"
    },
    {
      templateId: "446857",
      name: "Shotgun Raptor",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/craptor.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/craptor.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/craptor.mp4"
      },
      nation: "Silkhs",
      power: "100",
      rarity: "Common"
    },
    {
      templateId: "446858",
      name: "Shotgun Raptor",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/rraptor.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/rraptor.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/rraptor.mp4"
      },
      nation: "Silkhs",
      power: "200",
      rarity: "Toxic"
    },
    {
      templateId: "446859",
      name: "Shotgun Raptor",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/eraptor.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/eraptor.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/eraptor.mp4"
      },
      nation: "Silkhs",
      power: "300",
      rarity: "Frost"
    },
    {
      templateId: "446860",
      name: "Shotgun Raptor",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/lraptor.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/lraptor.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/lraptor.mp4"
      },
      nation: "Silkhs",
      power: "400",
      rarity: "Dark Matter"
    },
    {
      templateId: "446861",
      name: "Bjorn Hammer",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/chammer.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/chammer.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/chammer.mp4"
      },
      nation: "Silkhs",
      power: "100",
      rarity: "Common"
    },
    {
      templateId: "446862",
      name: "Bjorn Hammer",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/rhammer.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/rhammer.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/rhammer.mp4"
      },
      nation: "Silkhs",
      power: "200",
      rarity: "Toxic"
    },
    {
      templateId: "446863",
      name: "Bjorn Hammer",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/ehammer.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/ehammer.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/ehammer.mp4"
      },
      nation: "Silkhs",
      power: "300",
      rarity: "Frost"
    },
    {
      templateId: "446864",
      name: "Bjorn Hammer",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/lhammer.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/lhammer.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/lhammer.mp4"
      },
      nation: "Silkhs",
      power: "400",
      rarity: "Dark Matter"
    },
    {
      templateId: "446865",
      name: "Armagedon",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/carmagedon.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/carmagedon.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/carmagedon.mp4"
      },
      nation: "Arakneths",
      power: "110",
      rarity: "Common"
    },
    {
      templateId: "446866",
      name: "Armagedon",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/rarmagedon.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/rarmagedon.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/rarmagedon.mp4"
      },
      nation: "Arakneths",
      power: "220",
      rarity: "Toxic"
    },
    {
      templateId: "446867",
      name: "Armagedon",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/earmagedon.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/earmagedon.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/earmagedon.mp4"
      },
      nation: "Arakneths",
      power: "330",
      rarity: "Chalce"
    },
    {
      templateId: "446868",
      name: "Armagedon",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/larmagedon.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/larmagedon.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/larmagedon.mp4"
      },
      nation: "Arakneths",
      power: "440",
      rarity: "Dark Matter"
    },
    {
      templateId: "446869",
      name: "SR35-C",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/csr35c.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/csr35c.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/csr35c.mp4"
      },
      nation: "Arakneths",
      power: "110",
      rarity: "Common"
    },
    {
      templateId: "446870",
      name: "SR35-C",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/rsr35c.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/rsr35c.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/rsr35c.mp4"
      },
      nation: "Arakneths",
      power: "220",
      rarity: "Toxic"
    },
    {
      templateId: "446871",
      name: "SR35-C",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/esr35c.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/esr35c.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/esr35c.mp4"
      },
      nation: "Arakneths",
      power: "330",
      rarity: "Chalce"
    },
    {
      templateId: "446872",
      name: "SR35-C",
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/lsr35c.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/lsr35c.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/lsr35c.mp4"
      },
      nation: "Arakneths",
      power: "440",
      rarity: "Dark Matter"
    },
    {
      templateId: "446873",
      name: `Sahara's Damascus`,
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/csahara.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/csahara.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/csahara.mp4"
      },
      nation: "Arakneths",
      power: "110",
      rarity: "Common"
    },
    {
      templateId: "446874",
      name: `Sahara's Damascus`,
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/rsahara.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/rsahara.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/rsahara.mp4"
      },
      nation: "Arakneths",
      power: "220",
      rarity: "Toxic"
    },
    {
      templateId: "446875",
      name: `Sahara's Damascus`,
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/esahara.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/esahara.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/esahara.mp4"
      },
      nation: "Arakneths",
      power: "330",
      rarity: "Chalce"
    },
    {
      templateId: "446876",
      name: `Sahara's Damascus`,
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/lsahara.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/full_size/lsahara.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/weapons/mobile_size/lsahara.mp4"
      },
      nation: "Arakneths",
      power: "440",
      rarity: "Dark Matter"
    },
    {
      templateId: "452067",
      name: `Air Pistol`,
      img: "https://extinctionwars.com/assets/videos/visuals/weapons/AirPistol.mp4",
      nation: "Training Camp",
      power: "40",
      rarity: "Special"
    }
  ],
  suits: [
    {
      templateId: "446837",
      name: "Alpha",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/calpha.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/calpha.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/calpha.mp4"
      },
      nation: "Silkhs",
      power: "110",
      rarity: "Common"
    },
    {
      templateId: "446838",
      name: "Alpha",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/ralpha.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/ralpha.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/ralpha.mp4"
      },
      nation: "Silkhs",
      power: "220",
      rarity: "Bronze"
    },
    {
      templateId: "446839",
      name: "Alpha",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/ealpha.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/ealpha.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/ealpha.mp4"
      },
      nation: "Silkhs",
      power: "330",
      rarity: "Silver"
    },
    {
      templateId: "446840",
      name: "Alpha",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/lalpha.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/lalpha.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/lalpha.mp4"
      },
      nation: "Silkhs",
      power: "440",
      rarity: "Gold"
    },
    {
      templateId: "446841",
      name: "Delta",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/cdelta.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/cdelta.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/cdelta.mp4"
      },
      nation: "Silkhs",
      power: "110",
      rarity: "Common"
    },
    {
      templateId: "446842",
      name: "Delta",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/rdelta.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/rdelta.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/rdelta.mp4"
      },
      nation: "Silkhs",
      power: "220",
      rarity: "Bronze"
    },
    {
      templateId: "446843",
      name: "Delta",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/edelta.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/edelta.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/edelta.mp4"
      },
      nation: "Silkhs",
      power: "330",
      rarity: "Silver"
    },
    {
      templateId: "446844",
      name: "Delta",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/ldelta.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/ldelta.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/ldelta.mp4"
      },
      nation: "Silkhs",
      power: "440",
      rarity: "Gold"
    },
    {
      templateId: "446845",
      name: "Arak-32",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/carak32.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/carak32.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/carak32.mp4"
      },
      nation: "Arakneths",
      power: "100",
      rarity: "Common"
    },
    {
      templateId: "446846",
      name: "Arak-32",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/rarak32.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/rarak32.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/rarak32.mp4"
      },
      nation: "Arakneths",
      power: "200",
      rarity: "Bronze"
    },
    {
      templateId: "446847",
      name: "Arak-32",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/earak32.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/earak32.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/earak32.mp4"
      },
      nation: "Arakneths",
      power: "300",
      rarity: "Silver"
    },
    {
      templateId: "446848",
      name: "Arak-32",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/larak32.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/larak32.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/larak32.mp4"
      },
      nation: "Arakneths",
      power: "400",
      rarity: "Gold"
    },
    {
      templateId: "446849",
      name: "CW-18",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/ccw18.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/ccw18.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/ccw18.mp4"
      },
      nation: "Arakneths",
      power: "100",
      rarity: "Common"
    },
    {
      templateId: "446850",
      name: "CW-18",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/rcw18.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/rcw18.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/rcw18.mp4"
      },
      nation: "Arakneths",
      power: "200",
      rarity: "Bronze"
    },
    {
      templateId: "446851",
      name: "CW-18",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/ecw18.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/ecw18.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/ecw18.mp4"
      },
      nation: "Arakneths",
      power: "300",
      rarity: "Silver"
    },
    {
      templateId: "446852",
      name: "CW-18",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/lcw18.mp4",
      reveal_video: {
        full_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/full_size/lcw18.mp4",
        mobile_size:
          "https://extinctionwars.com/assets/videos/reveals_items/suits/mobile_size/lcw18.mp4"
      },
      nation: "Arakneths",
      power: "400",
      rarity: "Gold"
    },
    {
      templateId: "527436",
      name: "CW-18",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/tcw18.mp4",
      nation: "Arakneths",
      power: "350",
      rarity: "Special"
    },
    {
      templateId: "452066",
      name: "Dummy",
      img: "https://extinctionwars.com/assets/videos/visuals/suits/Dummy.mp4",
      nation: "Training Camp",
      power: "40",
      rarity: "Special"
    }
  ],
  reward_boxes: [
    {
      // START SILKHS TEMPLATE ID
      templateId: "446879",
      name: "Reward Box",
      rarity: "Common",
      nation: "Silkhs",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/csilkhs.mp4"
    },
    {
      templateId: "446880",
      name: "Reward Box",
      rarity: "Rare",
      nation: "Silkhs",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/rsilkhs.mp4"
    },
    {
      templateId: "446881",
      name: "Reward Box",
      rarity: "Epic",
      nation: "Silkhs",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/esilkhs.mp4"
    },
    {
      templateId: "446882",
      name: "Reward Box",
      rarity: "Legendary",
      nation: "Silkhs",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/lsilkhs.mp4"
    }, // <---
    {
      // START ARAK TEMPLATE ID
      templateId: "446883",
      name: "Reward Box",
      rarity: "Common",
      nation: "Arakneths",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/carakneths.mp4"
    },
    {
      templateId: "446884",
      name: "Reward Box",
      rarity: "Rare",
      nation: "Arakneths",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/rarakneths.mp4"
    },
    {
      templateId: "446885",
      name: "Reward Box",
      rarity: "Epic",
      nation: "Arakneths",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/earakneths.mp4"
    },
    {
      templateId: "446886",
      name: "Reward Box",
      rarity: "Legendary",
      nation: "Arakneths",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/larakneths.mp4"
    }, // <---
    {
      // START COUNCIL CITY TEMPLATE ID
      templateId: "448316",
      name: "Reward Box",
      rarity: "Common",
      nation: "Council City",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/ccouncil.mp4"
    },
    {
      templateId: "448318",
      name: "Reward Box",
      rarity: "Rare",
      nation: "Council City",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/rcouncil.mp4"
    },
    {
      templateId: "448319",
      name: "Reward Box",
      rarity: "Epic",
      nation: "Council City",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/ecouncil.mp4"
    },
    {
      templateId: "448320",
      name: "Reward Box",
      rarity: "Legendary",
      nation: "Council City",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/lcouncil.mp4"
    }, // <---
    {
      // TRAINING CAMP TEMPLATE ID
      templateId: "452068",
      name: "Reward Box",
      rarity: "Special",
      nation: "Training Camp",
      img: "https://extinctionwars.com/assets/videos/visuals/boxes-crates/dummies.mp4"
    }
  ],
  blueprints: {
    helmets: [
      {
        templateId: "447139",
        name: "Alpha Helmet",
        block_name: "Alpha",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/calpha.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/alphahelmet.png"
      },
      {
        templateId: "447143",
        name: "Delta Helmet",
        block_name: "Delta",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/cdelta.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/deltahelmet.png"
      },
      {
        templateId: "447147",
        name: "Arak-32 Helmet",
        block_name: "Arak32",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/carak32.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/arak32helmet.png"
      },
      {
        templateId: "447151",
        name: "CW-18 Helmet",
        block_name: "Cw18",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/ccw18.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/cw18helmet.png"
      }
    ],
    chests: [
      {
        templateId: "447140",
        name: "Alpha Chest",
        block_name: "Alpha",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/calpha.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/alphachest.png"
      },
      {
        templateId: "447144",
        name: "Delta Chest",
        block_name: "Delta",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/cdelta.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/deltachest.png"
      },
      {
        templateId: "447148",
        name: "Arak-32 Chest",
        block_name: "Arak32",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/carak32.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/arak32chest.png"
      },
      {
        templateId: "447152",
        name: "CW-18 Chest",
        block_name: "Cw18",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/ccw18.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/cw18chest.png"
      }
    ],
    arms: [
      {
        templateId: "447141",
        name: "Alpha Arms",
        block_name: "Alpha",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/calpha.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/alphaarms.png"
      },
      {
        templateId: "447145",
        name: "Delta Arms",
        block_name: "Delta",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/cdelta.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/deltaarms.png"
      },
      {
        templateId: "447149",
        name: "Arak-32 Arms",
        block_name: "Arak32",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/carak32.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/arak32arms.png"
      },
      {
        templateId: "447153",
        name: "CW-18 Arms",
        block_name: "Cw18",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/ccw18.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/cw18arms.png"
      }
    ],
    legs: [
      {
        templateId: "447142",
        name: "Alpha Legs",
        block_name: "Alpha",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/calpha.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/alphalegs.png"
      },
      {
        templateId: "447146",
        name: "Delta Legs",
        block_name: "Delta",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/cdelta.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/deltalegs.png"
      },
      {
        templateId: "447150",
        name: "Arak-32 Legs",
        block_name: "Arak32",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/carak32.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/arak32legs.png"
      },
      {
        templateId: "447154",
        name: "CW-18 Legs",
        block_name: "Cw18",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/suits/ccw18.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/cw18legs.png"
      }
    ],
    barrels: [
      {
        templateId: "447155",
        name: "AR-21 Barrel",
        block_name: "Ar21",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/car21.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/bar21.png"
      },
      {
        templateId: "449587",
        name: "Shotgun Raptor Barrel",
        block_name: "Raptor",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/craptor.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/braptor.png"
      },
      {
        templateId: "447163",
        name: "Bjorn Hammer Pen",
        block_name: "Hammer",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/chammer.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/phammer.png"
      },
      {
        templateId: "447167",
        name: "Armagedon Barrel",
        block_name: "Armagedon",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/carmagedon.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/barmagedon.png"
      },
      {
        templateId: "447172",
        name: "SR35-C Barrel",
        block_name: "Sr35c",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csr35c.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/bsr35c.png"
      },
      {
        templateId: "447177",
        name: `Sahara's Damascus Pen`,
        block_name: `Sahara's Damascus`,
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csahara.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/psahara.png"
      }
    ],
    bodies: [
      {
        templateId: "447156",
        name: "AR-21 Body",
        block_name: "Ar21",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/car21.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/bgar21.png"
      },
      {
        templateId: "447160",
        name: "Shotgun Raptor Body",
        block_name: "Raptor",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/craptor.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/bgraptor.png"
      },
      {
        templateId: "447166",
        name: "Bjorn Hammer Handle",
        block_name: "Hammer",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/chammer.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/hhammer.png"
      },
      {
        templateId: "447168",
        name: "Armagedon Body",
        block_name: "Armagedon",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/carmagedon.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/bgarmagedon.png"
      },
      {
        templateId: "447172",
        name: "SR35-C Body",
        block_name: "Sr35c",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csr35c.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/bgsrc35c.png"
      },
      {
        templateId: "447178",
        name: `Sahara's Damascus Handle`,
        block_name: `Sahara's Damascus`,
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csahara.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/hsahara.png"
      }
    ],
    stocks: [
      {
        templateId: "447158",
        name: "AR-21 Stock",
        block_name: "Ar21",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/car21.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/star21.png"
      },
      {
        templateId: "447161",
        name: "Shotgun Raptor Stock",
        block_name: "Raptor",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/craptor.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/sraptor.png"
      },
      {
        templateId: "447165",
        name: "Bjorn Hammer Face",
        block_name: "Hammer",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/chammer.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/fhammer.png"
      },
      {
        templateId: "447169",
        name: "Armagedon Stock",
        block_name: "Armagedon",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/carmagedon.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/sarmagedon.png"
      },
      {
        templateId: "447173",
        name: "SR35-C Stock",
        block_name: "Sr35c",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csr35c.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/ssr35c.png"
      },
      {
        templateId: "447175",
        name: `Sahara's Damascus Face`,
        block_name: `Sahara's Damascus`,
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csahara.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/fsahara.png"
      }
    ],
    magazines: [
      {
        templateId: "447151",
        name: "AR-21 Magazine",
        block_name: "Ar21",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/car21.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/mar21.png"
      },
      {
        templateId: "447162",
        name: "Shotgun Raptor Magazine",
        block_name: "Raptor",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/craptor.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/mraptor.png"
      },
      {
        templateId: "447164",
        name: "Bjorn Hammer Cheek",
        block_name: "Hammer",
        nation: "Silkhs",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/chammer.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/chhammer.png"
      },
      {
        templateId: "447170",
        name: "Armagedon Magazine",
        block_name: "Armagedon",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/carmagedon.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/margedon.png"
      },
      {
        templateId: "447174",
        name: "SR35-C Magazine",
        block_name: "Sr35c",
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csr35c.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/msrc35c.png"
      },
      {
        templateId: "447176",
        name: `Sahara's Damascus Cheek`,
        block_name: `Sahara's Damascus`,
        nation: "Arakneths",
        itemToBuild:
          "https://extinctionwars.com/assets/videos/visuals/weapons/csahara.mp4",
        img: "https://extinctionwars.com/assets/img/app-resources/blueprints-parts/chsahara.png"
      }
    ]
  }
};
